import { queryOptions, useInfiniteQuery } from "@tanstack/react-query";
import api from "../api/api";
import { BASE_API_URL } from "../routes";
import type {
  FindUserPackageBookingByIdOutputDto,
  FindUserPackageBookingsOutputDto,
} from "../types/codegen";

const PAGE_SIZE = 5;

export const useTripBookings = () => {
  const params = { perPage: PAGE_SIZE };

  return useInfiniteQuery({
    queryKey: ["user", "package-bookings", params] as const,
    queryFn: ({ pageParam, signal }) =>
      api
        .get<FindUserPackageBookingsOutputDto>(
          `${BASE_API_URL}/user/package-bookings`,
          {
            params: {
              ...params,
              page: pageParam,
            },
            signal,
          },
        )
        .then((res) => res.data),
    initialPageParam: 1,
    staleTime: 0,
    gcTime: 0,
    getNextPageParam: (lastPage, pages) => {
      const maxNumberOfPages = Math.ceil(lastPage.data.count / params.perPage);
      return pages.length < maxNumberOfPages ? pages.length + 1 : undefined;
    },
  });
};

export const tripBookingQueryOptions = (reservationId: string | undefined) =>
  queryOptions({
    queryKey: ["package-booking", reservationId],
    queryFn: ({ signal }) => {
      return api.get<FindUserPackageBookingByIdOutputDto>(
        `/user/package-bookings/${reservationId}`,
        {
          signal,
        },
      );
    },
    select: (response) => response.data?.data,
    enabled: Boolean(reservationId),
  });
